import axios from "axios";
import { sisikong_url } from "../index";

const EVENTNOTIFIER_API_URL = `${sisikong_url}/event/api/v1`;

export interface PushSubscriptionKeys {
  p256dh: string;
  auth: string;
}

export interface PushSubscriptionData {
  endpoint: string;
  keys: PushSubscriptionKeys;
  expirationTime?: number | null;
}

/**
 * Get VAPID public key from backend
 */
export async function getVapidPublicKey(): Promise<string | null> {
  try {
    const response = await axios.get(`${EVENTNOTIFIER_API_URL}/push/vapid-public-key`);
    return response.data.publicKey || null;
  } catch (error) {
    console.error("[Push] Failed to get VAPID public key:", error);
    return null;
  }
}

/**
 * Subscribe to push notifications
 */
export async function subscribeToPushNotifications(
  username: string,
  sourceEntity: string,
  subscription: PushSubscriptionData,
  token: string,
): Promise<boolean> {
  try {
    if (!token) {
      console.error("[Push] Not authenticated");
      return false;
    }

    await axios.post(
      `${EVENTNOTIFIER_API_URL}/push/subscribe`,
      {
        username,
        source_entity: sourceEntity,
        frontend: "apollo",
        subscription,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    console.log("[Push] Subscription sent to backend successfully");
    return true;
  } catch (error) {
    console.error("[Push] Failed to send subscription to backend:", error);
    return false;
  }
}

/**
 * Unsubscribe from push notifications
 * @param sourceEntity - Source entity identifier
 * @param username - Username
 * @param token - Authentication token
 * @param endpoint - Optional endpoint to unsubscribe specific device. If not provided, unsubscribes all devices.
 */
export async function unsubscribeFromPushNotifications(
  sourceEntity: string,
  username: string,
  token: string,
  endpoint?: string,
): Promise<boolean> {
  try {
    if (!token) {
      console.error("[Push] Not authenticated");
      return false;
    }

    const url = new URL(
      `${EVENTNOTIFIER_API_URL}/push/unsubscribe/${sourceEntity}/${username}/apollo`,
    );
    if (endpoint) {
      url.searchParams.set("endpoint", endpoint);
    }

    await axios.delete(url.toString(), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("[Push] Unsubscription sent to backend successfully");
    return true;
  } catch (error) {
    console.error("[Push] Failed to send unsubscription to backend:", error);
    return false;
  }
}
